<template>

  <header class="flex flex-col items-center justify-center bg-cover bg-center bg-no-repeat"
    :style="{ backgroundImage: 'url(' + require(`@/assets/background.png`) + ')' }">
    <div class="flex flex-col items-center my-28 font-antonio-light text-center px-4">

      <a href="https://cordobatechweek.com" target="web">
        <img class="w-full" src="@/assets/logo.png" />
      </a>

    </div>
  </header>

</template>

<script>
import VueScrollTo from 'vue-scrollto';

export default {
  methods: {
    scrollToForm() {
      VueScrollTo.scrollTo('#formulario', 500, {
        easing: 'ease-in-out',
      });
    },
  },
}

</script>